 document.addEventListener("DOMContentLoaded", function () {
    // Accordion behavior
    const questionss = document.querySelectorAll(".questionss");
    questionss.forEach(q => {
      q.addEventListener("click", () => {
        const active = document.querySelector(".questionss.active");
        if (active && active !== q) {
          active.classList.remove("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        q.classList.toggle("active");
        const ans = q.nextElementSibling;
        if (q.classList.contains("active")) {
          ans.style.maxHeight = ans.scrollHeight + "px";
        } else {
          ans.style.maxHeight = 0;
        }
      });
    });

    // "More FAQs" button logic
    const buttonMore = document.querySelector(".button-more");
    if (buttonMore) {
      buttonMore.addEventListener("click", () => {
        const hiddenFaqs = document.querySelectorAll(".q-anss.hiddens");
        hiddenFaqs.forEach(faq => faq.classList.remove("hiddens"));
        buttonMore.style.display = "none"; // hide button after showing all
      });
    }
  });